
<template>
    <div ref="listWrap">
        <wrapper-list
                @edit="paasEidtPage"
                @delete="paasDeleteTableData"
                @detail="paasDetailPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="商品名称" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_productName" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                    <FormItem label="商品sku" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_sku" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                    <FormItem label="退货单号" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_billCode" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar' //列表内操作
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import {changeStatus} from "@api/order.js";  //如果有枚举，需要引入
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList  ,CellBar, EnumShow},
        data() {
            return {
                serviceUrl:"/eb/order/aftersale/task",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_productName:"",
                    query_LIKE_sku:"",
                    query_LIKE_billCode:""
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '任务名称',
                        key: 'name',
                        width:350
                    },
                    {
                        title: '商品名称',
                        key: 'productName',
                    },
                    {
                        title: '商品sku',
                        key: 'sku',
                        width:120,
                    },
                    {
                        title: '数量',
                        key: 'num',
                        width:50
                    },
                    {
                        title: '任务状态',
                        key: 'taskStatus',
                        width:80,
                        render:(h,params)=>{
                            return  h(EnumShow, {
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'exceptionTaskStatus',
                                    value:params.row.taskStatus
                                },
                            })
                        }
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width:130
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 200,
                        render: (h, params) => {
                            let that = this;
                            let statusOperate = [];
                            let auditBtn = h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                        title: '系统提示',
                                        content: '确定已经收到退货了吗？',
                                        onOk: () => {
                                            that.updateStatus(params.row,"1");
                                            that.queryTableDatas();
                                        },
                                        onCancel: () => {
                                        this.$Modal.remove()
                                        }
                                    })
                                    }
                                }
                            }, '收货');
                            let processBtn = h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style:{
                                    marginLeft:'5px'
                                },
                                on: {
                                    click: () => {
                                        that.updateStatus(params.row,"2");
                                        that.queryTableDatas();
                                    }
                                }
                            }, '任务异常');
                            if(params.row.taskStatus == "0"){
                                statusOperate.push(auditBtn);
                                statusOperate.push(processBtn);
                            }
                            return h('div',statusOperate);
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
            /**
             * 更改任务状态
             */
           async updateStatus(row,type){
            let that  = this ;
                let data ={
                    id: row.id,
                    type: type
                }
                let code = await changeStatus(data); 
            }
        }
    }
</script>
